import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, Grid, Divider } from '@material-ui/core';

import iphoneImage from '../../assets/images/iphone.png';

import { MenuTabs } from '../../components';
import { RestaurantContext, LocationContext } from '../../context';

import logoTextIcon from '../../assets/logo-text-only.svg';

const useStyles = makeStyles((theme) => ({
  root: {},
  divider: {
    margin: theme.spacing(2, 0),
  },
  preview: {
    width: 370,
    height: 740,
    position: 'relative',
    margin: theme.spacing(4, 'auto'),
    padding: theme.spacing(7, 3),
    overflow: 'auto',

    display: 'flex',
    flexDirection: 'column',
  },
  downloadButton: {
    marginTop: theme.spacing(2),
  },
  iphoneImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
  },
  restaurantLogo: {
    maxWidth: 150,
    maxHeight: 45,
    margin: theme.spacing(1, 'auto'),
  },
  locationName: {
    margin: theme.spacing(1, 'auto'),
  },
  logo: {
    position: 'absolute',
    bottom: 40,
    left: 0,
    right: 0,
    margin: 'auto',
    maxWidth: 100,
    maxHeight: 16,
  },
  previewContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const LeftHand = () => {
  const classes = useStyles();

  const { restaurant } = useContext(RestaurantContext);
  const { selectedLocation } = useContext(LocationContext);

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Typography variant="h6">Your QR code</Typography>
          <Typography>This is your auto-generated QR Code.</Typography>
          <Button className={classes.downloadButton} variant="outlined" size="large">
            DOWNLOAD PRINT FILE
          </Button>
        </Grid>
        <Grid item xs={4}>
          QR code image
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <div>
        <Typography variant="h6">Preview your menu</Typography>
        <Typography>
          Below is what your customers will see when they scan your QR code.
        </Typography>
        <div className={classes.preview}>
          <div className={classes.previewContent}>
            {restaurant?.logoUrl && (
              <img
                className={classes.restaurantLogo}
                src={restaurant?.logoUrl}
                alt="Restaurant logo"
              />
            )}
            <Typography className={classes.locationName} component="p">
              {selectedLocation?.name}
            </Typography>
            <MenuTabs />
          </div>
          <img className={classes.iphoneImage} src={iphoneImage} alt="iphone" />
          <img className={classes.logo} src={logoTextIcon} alt="logo" />
        </div>
      </div>
    </div>
  );
};

export default LeftHand;
